import Cookies from 'js-cookie';

function getFavorites() {
    return JSON.parse(Cookies.get('ff_favorites') ?? '[]');
}

function setFavorites(favorites) {
    Cookies.set('ff_favorites', JSON.stringify(favorites), { expires: 365 });
    document.dispatchEvent(new CustomEvent('favoritesUpdated', { detail: { favorites } }));
}

function updateToggleStates() {
    document.querySelectorAll('[data-favorites-toggle]').forEach(function(toggle) {
        const postId = toggle.dataset.favoritesToggle;
        const favorites = getFavorites();

        if (favorites.includes(postId)) {
            toggle.classList.add('is-favorite');
        }
    });
}

function updateCounters() {
    const amount = getFavorites().length;

    document.querySelectorAll('[data-favorites-count]').forEach(function(count) {
        count.textContent = amount === 0 ? '' : amount;
    });
}

function handleClicks(event) {
    const selector = '[data-favorites-toggle]';
    let toggle;

    if (event.target.matches(selector)) {
        toggle = event.target;
    } else if (event.target.closest(selector)) {
        toggle = event.target.closest(selector);
    } else {
        return;
    }

    event.stopPropagation();
    event.preventDefault();

    const removeItem = event.target.closest('[data-favorites-remove]');
    const postId = toggle.dataset.favoritesToggle;
    const favorites = getFavorites();

    if (favorites.includes(postId)) {
        toggle.classList.remove('is-favorite');
        favorites.splice(favorites.indexOf(postId), 1);

        if (removeItem) {
            setTimeout(() => {
                removeItem.remove();
                document.dispatchEvent(new CustomEvent('favoriteRemoved', { detail: { postId } }));
            }, 300);
        }
    } else {
        toggle.classList.add('is-favorite');
        favorites.push(postId);
    }

    setFavorites(favorites);
    updateCounters();
}

document.addEventListener('click', handleClicks);
updateToggleStates();
updateCounters();